import styled from 'styled-components'
import { customTheme } from '../../../../styles/customTheme'

export const modalVincularOPStyles = {
  Form: styled.form`
    margin-bottom: 25px;

    input[type='number'] {
      -moz-appearance: textfield;
    }

    input[type='number']::-webkit-outer-spin-button,
    input[type='number']::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  `,
  ContainerDateInputs: styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
  `,
  SituacaoOp: styled.div`
    color: ${customTheme.colors.cinza04};
    border: 1px solid ${customTheme.colors.cinza04};
    border-radius: 4px;
    font-size: 1rem;
    font-weight: 500;
  `,
  ContainerBotoes: styled.div`
    display: flex;
    justify-content: end;
    gap: 12px;
    margin-top: 16px;
  `
}
